import CryptoJS from "crypto-js";

const Base64Key = process.env.REACT_APP_BASE_64_KEY ?? "";
const ivKey = process.env.REACT_APP_IV_KEY ?? "";

const key = CryptoJS.enc.Base64.parse(Base64Key);
const iv = CryptoJS.enc.Hex.parse("00000000000000000000000000000000");

export const decrypt = (cipherText: string) => {
  try {
    const decrypted = CryptoJS.AES.decrypt(cipherText, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    const result = decrypted.toString(CryptoJS.enc.Utf8);

    return result;
  } catch (e) {
    console.error("Decryption failed:", e);
    return "";
  }
};

export const decryptList = (cipherTexts: string[]) => {
  var result: string[] = [];
  cipherTexts.forEach((t) => {
    const decrypted = decrypt(t);
    result.push(decrypted);
  });

  return result;
};
